
	import {
		Component,
		Vue,
		Inject,
		Prop,
		Watch,
	} from 'vue-property-decorator';
	import Util from '@/lib/util';
	import wx from 'weixin-js-sdk';
	import AbpBase from '@/lib/abpbase';
	import Viewer from 'v-viewer'
	import 'viewerjs/dist/viewer.css'
	import liburl from '@/lib/url';
	import DropDownRefresh from '@/components/DropDownRefresh.vue'
	import AudioEnter from '@/components/AudioEnterReal.vue'
	import axios from 'axios'
	import ajax from '@/lib/ajax'
	import {
		Base64
	} from 'js-base64';



	import VueMarkdown from 'vue-markdown'
	@Component({
		components: {
			VueMarkdown,
			DropDownRefresh,
			AudioEnter
		}
	})
	export default class SessionAINEW extends AbpBase {
		userAgent : string = "";
		// sessinfo: Object = new Object() as any;
		sessinfo : Object = {
			id: 0
		}
		sid : number = 0;

		userid : number = 0;
		commentBox : boolean = false;
		isRefresh : boolean = true;
		historyList : Array<Object> = new Array<Object>();
		historyNew : Array<Object> = new Array<Object>();
		commentContent : string = "";
		loadmore : boolean = true;
		optertionInfo : Object = {
			likeId: 0,
			isLike: false,
			followId: 0,
			isFollow: false
		};
		userInfo : Object = new Object();
		anonymous : boolean = false;
		imgBox : boolean = false;
		currentImgs : Array<Object> = new Array<Object>();
		currentImgUrl : string = '';
		screenWidth : number = 0;
		appid : number = 0;
		showmenu : boolean = false;
		disabled : boolean = false;
		showHistory : boolean = false;
		isFresh : boolean = false;
		isSend : boolean = false;
		showTool : boolean = false;
		scrollHeight : number = 500;
		scrollid : string = "";
		prompt : string = "";
		imgurl : string = '';
		loadingType : number = 0;
		pagesize : number = 10;
		pageindex : number = 1;
		sessionid : string = "";
		sessionCount:number=0;

		actiontype : number = 0; //1 赞 2 踩
		ispc : boolean = false;

		ansterdata : string = "";
		answerstop : boolean = true;
		showstop : boolean = false;

		keyboardvic : number = 0;
		isShow : boolean = false;
		






		showShare : boolean = false;
		shownews : number = 0; // 0加载中 1 可见 2 不可见
		msg : string = '';
		isPreview : boolean = false;
		newsReadCount : number = 0;
		top : 0;
		startY : 0;
		isRefreshing : false;
		title : string = "";
		audioTitle : string = "";
		sendTitle : string = "";
		
		pcAudioTitle : string = "";
		pcSendTitle : string = "";
		
		audiostart(){
			var that=this;
			
			var websocket = new WebSocket("wss://tingwu-realtime-cn-beijing.aliyuncs.com/api/ws/v1?mc=p-7f1eXTYH7o8WZqNEq1mbecI1rtDZRllROA7d7Orp3MR9Nlv1epLAg0buQxhuL--2lAyRnmDv3zEnLPzAT2keBZpiTYh-AXGDa4yiw6F1U=")
			
			websocket.onopen = function () {
				console.log("WebSocket连接成功");
				websocket.send("");
			};
			
			websocket.onmessage = function (event) {
				console.log("接收到服务端消息：" + event.data)
				var result= JSON.parse(event.data);
				debugger
				if(result.header.name=="TaskFailed"){
					console.log(result.header.status_text)
				}
			};
			
			websocket.onerror = function () {
				console.log("WebSocket连接发生错误");
			};
			
			websocket.onclose = function () {
			console.log("WebSocket连接关闭");
			};
			
			return
			this.$store.dispatch({
				type: 'app/meetingCreate',
				data: {
					language:'cn',
					type: 2,
					format:'pcm',
					sampleRate:16000
				}
			}).then((res) => {
				debugger
				
			
			})
		}
		

		voiceChange() {
			if(!this.disabled){
				this.prompt="";
				this.keyboardvic = this.keyboardvic == 0 ? 1 : 0;
			}			
		}
		async closeAudio(data,touchEndTrans) {
			//console.log(touchEndTrans)
			var that = this;
			if(!that.disabled && data.size>100){
				var form = new FormData();
				form.append("upfile", data);
				var res = await this.$store.dispatch({
					type: 'app/speechProcess',
					data: form
				}).then((res) => {
					if (res.success) {
						console.log(res.msg)
						that.prompt=res.msg;
						
						if(!touchEndTrans){
							that.sessionSave();
						}
					}
					else{
						that.$Message.warning("解析失败")
					}
				
				})
			}
			
		}
		async sendAudio(content){
			this.prompt=content;
			//console.log(this.prompt)
			this.keyboardvic=0;
			this.sessionSave();
		}
		


		onRefresh(done) {
			var that = this;
			if (that.userid > 0) {
				// 如果下拉刷新和上拉加载同时使用，下拉时初始化上拉的数据
				console.log("done")
				if (that.loadingType != 0) { //loadingType!=0;直接返回

					that.isFresh = true;
					setTimeout(function () {

						that.isFresh = false;
						console.log(that.isFresh)
					}, 100)
					return false;
				}
				that.isFresh = true;
				this.load();
				that.showHistory = true;
				setTimeout(function () {

					that.isFresh = false;
					console.log(that.isFresh)

				}, 800)
			}
			done();

		}
		/**
		 * 上拉加载
		 */
		onInfiniteLoad(done) {
			console.log("load")
			done()
		}
		share() {
			this.showShare = true;

		}
		shareToWeixin(shareWeixinType) {
			var that = this;
			var sessinfo = (this.sessinfo as any);
			var title = sessinfo.prompt;
			var link = location.protocol + "//" + location.host + "/#/sessionai?sid=" + sessinfo.id;
			var content = "点击查看完整对话";
			title = title.substr(0, 20);
			//var coverImg = sessinfo.coverImg;
			if (content == '') {
				content = title;
			}
			// if (that.isIos()) {
			// 	that.$store.dispatch({
			// 		type: 'app/refreshOSSPresignedUri',
			// 		data: {
			// 			url: coverImg,
			// 			process: 'image/resize,m_fixed,w_30,h_30'
			// 		}
			// 	}).then(res => {
			// 		coverImg = res;
			// 		that.gisShareToWeixin(title, content, link, coverImg, shareWeixinType);
			// 	});
			// } else {
			that.gisShareToWeixin(title, content, link, "", shareWeixinType);
			//}

		}
		gisShareToWeixin(title, content, link, coverImg, shareWeixinType) {
			var that = this;
			// shareWeixinType: string = "WXSceneSession" // WXSceneTimeline
			(window as any).gis.shareToWeixin({
				type: 'web',
				title: title,
				content: content,
				href: link,
				thumbs: [""],
				extra: {
					scene: shareWeixinType
				},
				// pictures:[news.coverImg],
				success: function () {
					//that.showShare = false;
					//that.createNewsOperation(3);
				},
				fail: function () {
					that.showShare = false;
				}
			})
		}

		inputChange(e) {
			// if (e.target.value.length > 0) {
			// 	this.isSend = true;
			// } else {
			// 	this.isSend = false;
			// }
		}
		isIos() {
			var u = navigator.userAgent.toLowerCase();
			this.userAgent = u;
			if (u.indexOf("iphone") > -1 || u.indexOf("ios") > -1 || u.indexOf("mac") > -1) {
				return true;
			}
			return false;
		}
		load() {
			var that = this;
			that.loadSessionHistoryList();
		}
		minutesDifference(time1, time2) {
			// 将时间字符串转换为日期对象
			var date1 = new Date(time1);
			var date2 = new Date(time2);

			// 计算两个日期之间的毫秒差值
			var diff = date2.getTime() - date1.getTime();

			// 将毫秒差值转换为分钟
			return diff / (1000 * 60);
		}
		loadSessionHistoryList() {
			var that = this;

			that.loadingType = 1;

			var request = new Object() as any;
			request.maxResultCount = this.pagesize;
			request.skipCount = (this.pageindex - 1) * this.pagesize;
			request.appId = that.appid
			this.$store.dispatch({
				type: 'app/getSessionHistoryList',
				data: request
			}).then((res) => {
				var list = res.items;
				if (list.length < that.pagesize) {
					that.loadingType = 2;
					that.title = that.L("已无更多历史对话");
				} else {
					that.loadingType = 0; //将loadingType归0重置
					that.pageindex++;
				}
				var scrollid = "";
				for (var i = 0; i < list.length; i++) {
					var findindex = that.historyNew.findIndex(e => {
						return (e as any).id == list[i].id
					})
					if (findindex < 0) {
						list[i].isload = false;
						list[i].showdate = true;
						list[i].datetime = that.formatDateStr(list[i].creationTime);
						if (i < list.length - 1) {
							var date1 = list[i].creationTime;
							var date2 = list[i + 1].creationTime;
							var mins = that.minutesDifference(date2, date1);
							//console.log("date1:"+date2+",date2:"+date1+",mins:"+mins)
							if (mins < 5) {
								list[i].showdate = false;
							}
						}

						if (i == 0) {
							scrollid = "history-" + list[i].id;
						}
						that.historyList.unshift(list[i]);
					}
				}
				if (scrollid != '') {
					setTimeout(function () {
						that.scrollid = scrollid;
						console.log(that.scrollid)
						that.setpostion(scrollid)
						//	that.setpostion("history-0")
					}, 200)
				}

				console.log(that.historyList)


			})

		}
		setpostion(scrollid) {
			this.$nextTick(() => {
				const el = document.getElementById(scrollid);
				if (el) {
					// el.scrollIntoView({ behavior: 'smooth' });
					el.scrollIntoView(false);
					//el.scrollIntoView({ behavior: 'smooth' });
				}
			});
		}
		dianzan() {
			var that = this;
			var sid = (that.sessinfo as any).id;
			this.$store.dispatch({
				type: 'app/setSessionLike',
				data: {
					id: sid
				}
			}).then((res) => {
				if (that.actiontype == 0) {
					that.actiontype = 1;
				} else {
					that.actiontype = 0;
				}


			})
		}
		diancai() {
			var that = this;
			var sid = (that.sessinfo as any).id;
			this.$store.dispatch({
				type: 'app/setSessionStomp',
				data: {
					id: sid
				}
			}).then((res) => {
				if (that.actiontype == 0) {
					that.actiontype = 2;
				} else {
					that.actiontype = 0;
				}
			})
		}
		goStop() {
			var that = this;
			this.answerstop = true;
			this.disabled = false;
			this.showstop = true;
			console.log('stop');
		}

		againSend() {
			var that = this;
			that.historyList = [];
			that.loadingType = 0;
			that.scrollid = "";
			that.pageindex = 1;
			that.sessionid = "";
			that.historyNew = [];
			that.showHistory = false;
			that.showTool = false;
			that.showmenu = false;
		}
		refresh2() {
			if (this.loadingType == 0) { //loadingType!=0;直接返回

				// this.isFresh=false;
				// console.log(this.isFresh)
				return false;
			}
		}

		onScroll(event) {
			this.showmenu = false;

		}
		

		sessionSave() {
			var that = this;
			if (that.prompt.length == 0) {
				return;
			}
			var hour = (new Date()).getHours().toString();
			if (parseInt(hour) < 10) {
				hour = "0" + hour;
			}
			var mins = (new Date()).getMinutes().toString();
			if (parseInt(mins) < 10) {
				mins = "0" + mins;
			}
			var time = hour + ":" + mins;
			var showdate = false;
			if (that.historyNew.length == 0) {
				showdate = true
			}
			var info = {
				id: 0,
				prompt: that.prompt,
				answer: '',
				isload: true,
				showdate: showdate,
				datetime: time,
				voice:that.keyboardvic
			}

			var scrollid = "prompt-" + info.id;
			// setTimeout(function() {
			// 	that.scrollid = scrollid;
			// 	that.setpostion("history-0")
			// }, 200)

			that.historyNew.push(info);
			that.prompt = '';
			that.isSend = false;
			that.disabled = true;
			that.sessinfo = info;
			that.actiontype = 0;
			that.setpostion("history-0")

			var para = {
				prompt: info.prompt,
				appId: that.appid,
				sessionId: that.sessionid,
				userId: that.userid
			}

			var basepro = Base64.encode(info.prompt.trim()).replaceAll("+", "%2B");
			// setTimeout(function(){
			// 	that.disabled=false
			// },2000)
			// return

			//var bas = Base64.encode(JSON.stringify(para)) ;			

			var source = new EventSource(liburl + "/api/SessionAI/SessionCompletion?prompt=" + basepro + "&appId=" +
				that.appid + "&sessionId=" + that.sessionid + "&userId=" + that.userid);
			//var source = new EventSource(liburl + "/api/SessionAI/SessionCompletion?params=" + bas )
			source.onopen = function (event) {
				console.log("建立连接..." + "<br/>")
				that.answerstop = false;

				//$("#result").prepend("建立鏈接..." + "<br/>")
			};
			source.onmessage = function (event) {
				//console.log(event.data)
				if (event.data.indexOf('end-') > -1) {
					that.disabled = false;
					console.log(event.data);

					var history = that.historyNew[that.historyNew.length - 1];
					var rid = event.data.replace('end-', '');
					var ridarr=rid.split('-');
					if(ridarr.length>0){
						rid=ridarr[0];
					}
					if(ridarr.length>1){
						if(that.sessionCount>=5){
							that.sessionCount=0;
							that.sessionid="";
						}
						else{
							that.sessionid = ridarr[1];
							that.sessionCount++;
						}
						
					}
					(history as any).isload = false;
					(history as any).id = rid;
					(that.sessinfo as any).id = rid;
					that.showTool = true;
					that.showstop = false;
					//that.$Message.success(event.data)

				} else {
					if (!that.answerstop) {
						var history = that.historyNew[that.historyNew.length - 1];

						(history as any).isload = false;
						var answer = (history as any).answer;
						try {
							var rsp = JSON.parse(event.data).response;
							(history as any).answer = JSON.parse(event.data).response;
							that.ansterdata = rsp;
						} catch (e) {
							//TODO handle the exception
							(history as any).answer += event.data;
							that.ansterdata += event.data;
						}
					}


					//(history as any).answer+=event.data


					// var response=JSON.parse(event.data).response.replace(answer,'');
					// var response=event.data.replace(answer,'');
					// var i=0;
					//  var showChar = function() {
					//         if (i < response.length) {
					//             (that.historyNew[that.historyNew.length - 1] as any).answer += response[i++]; // 添加字符并递增索引
					//             setTimeout(showChar, 100); // 每100毫秒显示下一个字符
					//         }
					//     };




					//(history as any).answer = JSON.parse(event.data).response;
				}

				//$("#result").prepend(event.data + "<br/>")
			};
			source.onerror = function (event) {
				console.log("关闭连接..." + "<br/>")
				that.answerstop = true;
				var history = that.historyNew[that.historyNew.length - 1];
				(history as any).isload = false;
				if ((history as any).answer == '') {
					(history as any).answer = "很抱歉，请稍后再试";
					(history as any).id = -1;
				}
				that.showstop = false;
				that.disabled = false;
				//$("#result").prepend("關閉鏈接..." + "<br/>")
				source.close();
			}
		}


		getAIListAll() {
			var that = this;
			var request = new Object() as any;
			request.maxResultCount = 100;
			request.skipCount = 1;

			this.$store.dispatch({
				type: 'app/getAIListAll',
				data: request
			}).then((res) => {

				var result = res.items;
				if (result.length > 0) {
					that.appid = result[0].id
					console.log(that.appid);
				}

			})
		}
		getLoginUser() {
			var that = this;
			this.$store.dispatch({
				type: 'app/getLoginUser',
				data: {}
			}).then(res => {
				that.userid = res.id;
				that.userInfo = res;
			})
		}
		formatDateStr(dateString) {
			var that = this;
			if (dateString != null && dateString.length > 0) {
				dateString = dateString.substr(0, 19);
				dateString = dateString.replace(/-/g, "/").replace(/T/g, " ");

				var datetime = new Date(dateString);
				var dateTimeStamp = datetime.getTime();

				var minute = 1000 * 60; //把分，时，天，周，半个月，一个月用毫秒表示
				var hour = minute * 60;
				var day = hour * 24;
				var week = day * 7;
				var halfamonth = day * 15;
				var month = day * 30;
				var now = new Date().getTime(); //获取当前时间毫秒
				var diffValue = now - dateTimeStamp; //时间差

				if (diffValue < 0) {
					console.log("diffValue<0", datetime, dateTimeStamp, now, diffValue);
					return that.L('刚刚');
				}
				var minC = diffValue / minute; //计算时间差的分，时，天，周，月
				var hourC = diffValue / hour;
				var dayC = diffValue / day;
				var weekC = diffValue / week;
				var monthC = diffValue / month;
				var result = "";
				if (datetime.getFullYear() == new Date().getFullYear() && monthC >= 1 && monthC <= 12) {
					//result = " " + parseInt(monthC) + "月前"
					result = this.formatDate(datetime, 'MM-dd hh:mm')
				} else if (weekC >= 1 && weekC <= 4) {
					//result = " " + parseInt(weekC) + "周前"
					result = this.formatDate(datetime, 'MM-dd hh:mm')
				} else if (dayC >= 1 && dayC <= 7) {
					if (datetime.getDate() == new Date().getDate() - 1) {
						result = that.L('昨天') + ' ' + this.formatDate(datetime, 'hh:mm')
					} else if (datetime.getDate() == new Date().getDate() - 2) {
						//result = "前天 " + this.formatDate(datetime, 'hh:mm')
						result = this.formatDate(datetime, 'MM-dd hh:mm')
					} else {
						//result = " " + parseInt(dayC) + "天前"
						result = this.formatDate(datetime, 'MM-dd hh:mm')
					}

				} else if (hourC >= 1 && hourC <= 24) {
					if (datetime.getDate() == new Date().getDate()) {
						result = that.L('今天') + ' ' + this.formatDate(datetime, 'hh:mm')
					} else {
						result = that.L('昨天') + ' ' + this.formatDate(datetime, 'hh:mm')
					}
					//result = " " + parseInt(hourC) + "小时前"
				} else if (minC >= 1 && minC <= 59) {
					result = " " + minC.toFixed(0) + that.L('分钟前')
				} else if (diffValue >= 0 && diffValue <= minute) {
					result = that.L('刚刚');
				} else {
					var datetime = new Date();
					datetime.setTime(dateTimeStamp);
					var Nyear = datetime.getFullYear(); { }
					var Nmonth = datetime.getMonth() + 1 < 10 ? "0" + (datetime.getMonth() + 1) : datetime.getMonth() +
						1;
					var Ndate = datetime.getDate() < 10 ? "0" + datetime.getDate() : datetime.getDate();
					var Nhour = datetime.getHours() < 10 ? "0" + datetime.getHours() : datetime.getHours();
					var Nminute = datetime.getMinutes() < 10 ? "0" + datetime.getMinutes() : datetime.getMinutes();
					var Nsecond = datetime.getSeconds() < 10 ? "0" + datetime.getSeconds() : datetime.getSeconds();
					result = Nyear + "-" + Nmonth + "-" + Ndate
				}
				return result;

			}
		}
		formatDate(date, fmt) {
			if (date != null) {
				if (/(y+)/.test(fmt)) {
					fmt = fmt.replace(RegExp.$1, (date.getFullYear() + '').substr(4 - RegExp.$1.length));
				}
				// // #ifdef APP-PLUS  
				// date.setHours(date.getHours()-8);
				// // #endif 
				let o = {
					'M+': date.getMonth() + 1,
					'd+': date.getDate(),
					'h+': date.getHours(),
					'm+': date.getMinutes(),
					's+': date.getSeconds()
				};
				for (let k in o) {
					if (new RegExp(`(${k})`).test(fmt)) {
						let str = o[k] + '';
						fmt = fmt.replace(RegExp.$1, (RegExp.$1.length === 1) ? str : this.padLeftZero(str));
					}
				}
				return fmt;
			} else {
				return '';
			}

		}
		padLeftZero(str) {
			return ('00' + str).substr(str.length);
		}
		getSessionInfo() {
			var that = this;
			var that = this;
			var request = new Object() as any;
			request.maxResultCount = this.pagesize;
			request.skipCount = (this.pageindex - 1) * this.pagesize;
			request.id = that.sid
			request.onlyMy = false;
			this.$store.dispatch({
				type: 'app/getSessionHistoryList',
				data: request
			}).then((res) => {
				var list = res.items;
				if (list.length > 0) {
					that.historyList.push(list[0]);
				}
			})
		}


		@Watch('ansterdata')
		ansterdataChange(newItems) {
			var that = this;
			that.setpostion("history-0")

			// 监听数据变化，当数据增加时自动滚动
			// this.$nextTick(() => {		     
			//     let chat = this.$refs.history0;
			//       chat.scrollTop = chat.scrollHeight
			// });
		}





		@Watch('$route')
		routechange(to : any, from : any) {
			if (to.query.sid != from.query.sid) {
				location.reload();
			}
		}
		async created() {
			var that = this;

			that.title = that.L("开启了新话题，下拉回顾")
			that.audioTitle=that.L("按住说话");
			that.sendTitle=that.L("松开发送，上滑取消");
			that.pcAudioTitle=that.L("点击开始录音");
			that.pcSendTitle=that.L("点击停止录音");
			that.screenWidth = document.body.clientWidth
			window.document.title = that.L("AI对话");


			//localStorage.setItem("AcTitle","AI对话")

			var u = navigator.userAgent.toLowerCase();
			console.log(navigator.userAgent)
			if (u.indexOf('iphone') > -1 || u.indexOf('ipad') > -1 || u.indexOf('ipod') > -1 || u.indexOf('android ') >
				-1) {
				console.log('当前在手机端');
				that.ispc = false
			} else {
				console.log('当前在PC端');
				that.ispc = true;
				that.title = that.L("点击回顾历史");
			}
			
			that.sessionCount=0;
			that.sessionid="";


			if (Util.abp.session.userId) {
				this.userid = Util.abp.session.userId;
				this.getLoginUser();
			}
			if (!Util.abp.session.userId) {
				var domain = this.$route.query.domain as any;
				if (domain != undefined && domain != null && domain != '') {
					await this.$store.dispatch({
						type: 'app/externalAuthenticate',
						data: {
							"AuthProvider": "IDSDOMAIN",
							"ProviderAccessCode": domain,
							ProviderKey: "",
							Property: ""
						},
					})
					location.reload();
				}
				var userId = this.$route.query.userid as any;
				if (userId != undefined && userId != null && userId != '') {
					await this.$store.dispatch({
						type: 'app/externalAuthenticate',
						data: {
							"AuthProvider": "IDSID",
							"ProviderAccessCode": userId,
							ProviderKey: userId,
							Property: ""
						},
					})
					location.reload();
				}
			}



			if (this.$route.query.sid && (this.$route.query.sid as any) > 0) {
				this.sid = this.$route.query.sid as any;

				if (Util.abp.session.userId) {
					this.userid = Util.abp.session.userId;
					this.getLoginUser();


				}
				this.getSessionInfo();
			}
			if (this.userid > 0) {
				this.getAIListAll();
			} else {
				this.isRefresh = false;
				that.title = ""
			}

		}
		mounted() {
			var that = this;
			this.$nextTick(() => {
				this.$refs.gethistoryheight
			})

			this.$nextTick(() => {
				let elementHeight = (this.$refs.aibox as any).offsetHeight;
				that.scrollHeight = elementHeight - 130;
				console.log('元素高度:', elementHeight);
			});

		}
	};
